import { Directive, ElementRef, Injector, Input } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";
import { IGif, SizeOfGif } from "@webapp/shared/rich-text-editor/add-gif/add-gif.models";

@Directive({
  selector: "gif-view",
})
export class GifViewDirective extends UpgradeComponent {
  @Input() public gifSize: SizeOfGif;
  @Input() public gif: IGif;
  @Input() public showClearBtn: boolean;

  constructor(elementRef: ElementRef, injector: Injector) {
    super("gifView", elementRef, injector);
  }
}
